import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";

const mapContainerStyle = { width: "100%", height: "400px", borderRadius: "8px" };

export default function SelectionScreen() {
  const { user, saveLocationContext } = useContext(AuthContext);
  const navigate = useNavigate();
  const [selection, setSelection] = useState(null);
  const [inputLat, setInputLat] = useState("");
  const [inputLon, setInputLon] = useState("");
  const [localMachine, setLocalMachine] = useState(false); // Privzeto false
  const [mapLocation, setMapLocation] = useState({ lat: 46.0, lng: 15.0 });
  const [showMapInstructions, setShowMapInstructions] = useState(false);
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBCQdt2iyMPEu_zeTLximpbgHJ6pOMLwHE",
  });

  const handleSaveLocation = async (lat, lon) => {
    const loc = { latitude: lat, longitude: lon, localMachine };
    try {
      const userDocRef = doc(db, "users", user.uid);
      await setDoc(userDocRef, { location: loc }, { merge: true });
      console.log("Shranjena lokacija:", loc); // Beleženje za preverjanje
      saveLocationContext(loc);
      navigate("/domov");
    } catch (error) {
      console.error("Napaka pri shranjevanju lokacije:", error);
      alert("Napaka pri shranjevanju lokacije. Poskusite znova.");
    }
  };

  const handleUseStoredLocation = async () => {
    try {
      const userDocRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(userDocRef);
      if (docSnap.exists() && docSnap.data().location) {
        const { latitude, longitude, localMachine: savedLocal } = docSnap.data().location;
        const loc = { latitude, longitude, localMachine: savedLocal !== undefined ? savedLocal : false }; // Privzeto false
        setLocalMachine(savedLocal !== undefined ? savedLocal : false);
        console.log("Prebrana shranjena lokacija:", loc); // Beleženje za preverjanje
        saveLocationContext(loc);
        navigate("/domov");
      } else {
        alert("Ni shranjene lokacije v bazi.");
      }
    } catch (error) {
      console.error("Napaka pri branju shranjene lokacije:", error);
      alert("Napaka pri branju shranjene lokacije. Poskusite znova.");
    }
  };

  const submitLatLon = () => {
  
  const latStr = inputLat.replace(',', '.').trim();
  const lonStr = inputLon.replace(',', '.').trim();

  const lat = parseFloat(latStr);
  const lon = parseFloat(lonStr);
  if (
    isNaN(lat) ||
    isNaN(lon) ||
    lat < 45.4 || // Minimalna latitude za Slovenijo
    lat > 46.9 || // Maksimalna latitude za Slovenijo
    lon < 13.4 || // Minimalna longitude za Slovenijo
    lon > 16.6 // Maksimalna longitude za Slovenijo
  ) {
    alert("Vnesite veljavne koordinate znotraj Slovenije (lat: 45,4 do 46,9, lon: 13,4 do 16,6)!");
    return;
  }
  handleSaveLocation(lat, lon);
};

  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setMapLocation({ lat, lng });
  };

  const confirmMapLocation = () => {
    handleSaveLocation(mapLocation.lat, mapLocation.lng);
  };

  if (!user) return <p style={{ textAlign: "center", marginTop: 50 }}>Nalaganje...</p>;

  return (
    <div style={containerStyle}>
      <h1 style={{ textAlign: "center", marginBottom: 30 }}>Izberi lokacijo naprave</h1>
      {/* --- Gumbi za izbiro metode --- */}
      <div style={buttonGroupStyle}>
        <button style={buttonStyle} onClick={() => setSelection(1)}>✏️ Vpiši lat/lon</button>
        <button
          style={buttonStyle}
          onClick={() => {
            setSelection(2);
            setShowMapInstructions(true);
          }}
        >
          🌍 Na zemljevidu
        </button>
        <button
          style={{ ...buttonStyle, backgroundColor: "#2ecc71" }}
          onClick={handleUseStoredLocation}
        >
          💾 Uporabi shranjeno lokacijo
        </button>
      </div>
      {/* --- Lat/Lon Input --- */}
      {selection === 1 && (
        <div style={cardStyle}>
          <p>Geografska dolžina</p>
          <input
            placeholder="Lat: 45,4 do 46,9"
            value={inputLat}
            onChange={(e) => setInputLat(e.target.value)}
            style={inputStyle}
          />
          <p>Geografska širina</p>
          <input
            placeholder="Lon: 13,4 do 16,6"
            value={inputLon}
            onChange={(e) => setInputLon(e.target.value)}
            style={inputStyle}
          />
          <br></br>
          <br></br>
          <button style={buttonStyle} onClick={submitLatLon}>Shrani</button>
        </div>
      )}
      {/* --- Map --- */}
      {selection === 2 && isLoaded && (
        <div style={cardStyle}>
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            zoom={7}
            center={mapLocation}
            onClick={handleMapClick}
          >
            <Marker position={mapLocation} />
          </GoogleMap>
          <button style={{ ...buttonStyle, marginTop: 15 }} onClick={confirmMapLocation}>
            Potrdi lokacijo
          </button>
        </div>
      )}
      {/* --- Popup z navodili --- */}
      {showMapInstructions && (
        <div style={popupStyle}>
          <p>
            Na zemljevidu približajte interesno območje in nato kliknite, da določite lokacijo.
            Če želite lokacijo popraviti, kliknite ponovno in nato potrdite s klikom na "Potrdi lokacijo".
          </p>
          <button style={buttonStyle} onClick={() => setShowMapInstructions(false)}>OK</button>
        </div>
      )}
      {/* --- Local machine checkbox --- */}
      <div style={cardStyle}>
        <label style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <input
            type="checkbox"
            checked={localMachine}
            onChange={() => {
              setLocalMachine(!localMachine);
              console.log("Checkbox spremenjen, localMachine:", !localMachine); // Beleženje
            }}
          />
          Uporaba lokalne merilne naprave
        </label>
      </div>
    </div>
  );
}

// --- Styling ---
const containerStyle = {
  maxWidth: "800px",
  margin: "40px auto",
  padding: 20,
  fontFamily: "Arial, sans-serif",
};

const buttonGroupStyle = {
  display: "flex",
  justifyContent: "center",
  gap: 15,
  marginBottom: 20,
};

const buttonStyle = {
  padding: "10px 15px",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
  backgroundColor: "#3498db",
  color: "#fff",
  fontWeight: "bold",
  fontSize: 14,
};

const cardStyle = {
  backgroundColor: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  marginBottom: 20,
};

const inputStyle = {
  padding: "8px 10px",
  marginRight: 10,
  borderRadius: 6,
  border: "1px solid #ccc",
  fontSize: 14,
};

const popupStyle = {
  position: "fixed",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
  zIndex: 1000,
  maxWidth: "400px",
  textAlign: "center",
};